import { CA_PROVINCES } from './countries.ts';

export const ES_REGIONS = [
  { name: 'Andalucía', code: 'AN' },
  { name: 'Aragón', code: 'AR' },
  { name: 'Asturias', code: 'AS' },
  { name: 'Canarias', code: 'CN' },
  { name: 'Cantabria', code: 'CB' },
  { name: 'Castilla-La Mancha', code: 'CM' },
  { name: 'Castilla y León', code: 'CL' },
  { name: 'Cataluña', code: 'CT' },
  { name: 'Comunidad Valenciana', code: 'VC' },
  { name: 'Ceuta', code: 'CE' },
  { name: 'Extranjero', code: 'ET' },
  { name: 'Extremadura', code: 'EX' },
  { name: 'Galicia', code: 'GA' },
  { name: 'Islas Baleares', code: 'IB' },
  { name: 'La Rioja', code: 'RI' },
  { name: 'Madrid', code: 'MD' },
  { name: 'Melilla', code: 'ML' },
  { name: 'Murcia', code: 'MU' },
  { name: 'Navarra', code: 'NC' },
  { name: 'País Vasco: Diputación Foral de Álava', code: 'VI' },
  { name: 'País Vasco: Diputación Foral de Guipúzcoa', code: 'SS' },
  { name: 'País Vasco: Diputación Foral de Vizcaya', code: 'BI' },
] as const;

export const selectDrawerData = {
  region: {
    options:              ES_REGIONS,
    metadataInitialValue: 'provinceCode',
  },
  province: {
    options:              CA_PROVINCES,
    metadataInitialValue: '',
  },
}
